import { useEffect, useState } from "react";
import MarkdownMessage from "../MarkdownMessage";

interface Props {
  text: string;
  speed?: number;
}

export default function TypingMessage({ text, speed = 15 }: Props) {
  const [displayed, setDisplayed] = useState("");

  useEffect(() => {
    let i = 0;
    setDisplayed("");

    const interval = setInterval(() => {
      i++;
      setDisplayed(text.slice(0, i));

      if (i >= text.length) {
        clearInterval(interval);
      }
    }, speed);

    return () => clearInterval(interval);
  }, [text, speed]);

  return <MarkdownMessage content={displayed} />;
}